import React from "react";
import DatabaseStats from "../components/DatabaseStats";
import DownloadTable from "../components/DownloadTable";

function Database() {
  return (
    <div className="p-6 max-w-screen-xl mx-auto">
      {/* Database Statistics Section */}
      <DatabaseStats />
      
      {/* Download Section */}
      <div className="mt-12 text-lg">
        <h2 className="text-4xl font-bold mb-6 text-[#4e5a4c]">📦 PlasAnn Database Download</h2>
        <p className="mb-6 text-gray-600">
          Click on a file name to download it individually. All files are hosted on Zenodo.
        </p>
        <DownloadTable />
      </div>
    </div>
  );
}

export default Database;